"use client";

import { useEffect, useLayoutEffect } from "react";
import { useMotionValue } from "@/hooks/useFramerMotion";
import { connectDocumentScrollY } from "./useDocumentScrollY";

const useClientLayoutEffect =
  typeof window === "undefined" ? useEffect : useLayoutEffect;

export function useDocumentScroll() {
  const scrollY = useMotionValue(0);
  const scrollYProgress = useMotionValue(0);
  useClientLayoutEffect(
    () => connectDocumentScrollY(scrollY, scrollYProgress),
    [scrollY, scrollYProgress]
  );
  return { scrollY, scrollYProgress };
}
